import { inject, TemplateRef } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ETicketType, ITicketCategory } from '@web/dtos';

export const DEFAULT_DIALOG_WIDTH = '600px';

export type IDialogData = {
  width?: string;
  headline: string;
  icon?: string;
  iconBackgroundColor?: string;
  fontSize?: number;
};

export type ITemplateDialogData = IDialogData & {
  content: TemplateRef<unknown>;
  footer?: TemplateRef<unknown>;
  subtitle?: string;
  closingColor?: string;
  isValid?: boolean;
  isSaveDialog?: boolean;
};

export type IDialogDataWithTicketCategory = IDialogData & {
  ticketCategory: ITicketCategory;
};

export type IDialogDataWithTicketType = IDialogData & {
  ticketType: ETicketType;
};

export interface IDialogResponse<T> {
  submit: boolean;
  data: T;
  acceptChanges: boolean;
}

export class Dialog<T> {
  public readonly dialogRef: DialogRef<IDialogResponse<T>> = inject<
    DialogRef<IDialogResponse<T>>
  >(DialogRef<IDialogResponse<T>>);
  public data: IDialogData & T = inject(DIALOG_DATA);

  public get width(): string {
    return this.data.width ?? DEFAULT_DIALOG_WIDTH;
  }
}
